module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pwd_hint":"Your password","pwd_label":"Password","pwd_required":"You must provide a password","pwd_length":"Your password must be at least 4 characters long"},"fr":{"pwd_hint":"Votre mot de passe sécurisé","pwd_label":"Mot de passe","pwd_required":"Vous devez renseigner un mot de passe","pwd_length":"Le mot de passe doit contenir au moins 4 caractères"}}')
  delete Component.options._Ctor
}
